import { render, staticRenderFns } from "./social-networks.vue?vue&type=template&id=0242b116&"
import script from "./social-networks.vue?vue&type=script&lang=js&"
export * from "./social-networks.vue?vue&type=script&lang=js&"
import style0 from "./social-networks.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0242b116')) {
      api.createRecord('0242b116', component.options)
    } else {
      api.reload('0242b116', component.options)
    }
    module.hot.accept("./social-networks.vue?vue&type=template&id=0242b116&", function () {
      api.rerender('0242b116', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/common/social-networks/social-networks.vue"
export default component.exports